import { PropTypes } from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const SpanTag = styled.span`
  ${(props) => props.type === 'card' && css`
    display: block;
    transform-origin: center;
    cursor: pointer;
    background: center /contain no-repeat;
    width: 223px;
    height: 275px;
    
    ${props.back ? 'background-image: url("'+ props.wsrc+'")' : 'background-image: url("'+props.src+'")'};

    &.ani1 {
      transform: scale(100%);
      animation: ani1 0.6s ease-in-out;
      animation-play-state: running;
    }
  
    @keyframes ani1 {
      0% {
        transform: scale(100%);
      }
  
      50% {
        transform: scale(110%);
      }
  
      100% {
        transform: scale(100%);
      }
    }

    &.ani2 {
      animation: ani2 0.6s ease-in-out;
      animation-play-state: running;
    }

    @keyframes ani2 {
      0% {
        transform: scale(100%);
      }

      50% {
        transform: scale(110%);
      }

      100% {
        transform: scale(100%);
      }
    }

    &.ani3 {
      transform: scale(100%);
      animation: ani3 0.6s ease-in-out;
      animation-play-state: running;
    }

    @keyframes ani3 {
      0% {
        transform: scale(70%);
      }

      100% {
        transform: scale(100%);
      }
    }

    &.ani4 {
      transform: scale(70%);
      animation: ani4 0.6s ease-in-out;
      animation-play-state: running;
    }

    @keyframes ani4 {
      0% {
        transform: scale(100%);
      }

      100% {
        transform: scale(70%);
      }
    }
  `}

`;

export const Span = (props) => {
  return (
    <SpanTag 
      type={props.type} 
      src={props.src} 
      wsrc={props.wsrc}
      act={props.act}
      choice={props.choice}
      back={props.back}
      reset={props.reset}
      className={props.className}
      onClick={props.onClick}
    >
    </SpanTag>
  );
};

Span.propTypes = {
  type : PropTypes.string,
  src : PropTypes.string,
};

Span.defaultProps = {
  type : 'card',
  src : "https://content.chungchy.com/PhonicsHero/web_resource/book1/flashCard/b1-unit1-alligator_optimized.png",
  wsrc : "https://content.chungchy.com/PhonicsHero/web_resource/book1/flashCard/b1-unit1-w-alligator_optimized.png",
}